import React from 'react';
import classNames from 'classnames';

import { IconTypes } from '../../../types';

type LogoOnlyProps = {
  variant?: 'original' | 'black' | 'white';
};

export const LogoOnly = ({
  className,
  width = 51,
  height = 24,
  variant = 'original',
  ariaHidden = true,
  isClickable = false,
}: LogoOnlyProps & IconTypes): React.ReactElement => {
  const defaultClass = classNames(
    'sui-fill-current',
    { 'sui-pointer-events-none': !isClickable },
    className
  );

  let color1;
  let color2;

  switch (variant) {
    case 'black':
      color1 = '#000';
      color2 = '#000';
      break;

    case 'white':
      color1 = '#fff';
      color2 = '#fff';
      break;

    case 'original':
      color1 = '#4B286D';
      color2 = '#66CC00';
      break;
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={defaultClass}
      aria-hidden={ariaHidden}
    >
      <path
        d="M50.428 0.466904L28.4825 4.85601V6.35017H28.5759C43.0506 2.80153 50.428 0.74706 50.5214 0.74706C50.6148 0.74706 50.6148 0.653674 50.6148 0.560289C50.6148 0.466904 50.5214 0.373519 50.428 0.466904Z"
        fill={color1}
      />
      <path
        d="M32.5914 0C31.5642 0.0933852 29.5097 1.58755 28.4825 2.61479C24.0934 6.35019 20.9183 9.80545 18.5837 13.3541C13.7276 15.9689 7.47082 18.677 1.30739 20.7315L1.12062 20.8249L0 24L0.653696 23.7198C4.57587 22.2257 11.1128 19.4241 16.9961 16.3424C16.6226 17.2763 16.5292 18.1167 16.5292 18.7704C16.5292 19.3307 16.6226 19.7977 16.8093 20.2646C17.1829 21.1984 17.93 21.8521 18.9572 22.3191C20.4514 22.9728 22.5992 22.9728 24.9339 22.2257C31.0039 20.358 38.1945 14.8482 39.6887 13.7276L39.7821 13.6342C39.8755 13.5409 39.8755 13.5409 39.8755 13.4475C39.8755 13.4475 39.7821 13.3541 39.6887 13.4475L39.5953 13.5409C37.9144 14.5681 29.7899 19.4241 24.4669 20.8249C21.7588 21.572 19.7043 21.1051 18.9572 20.0778C18.677 19.7043 18.5837 19.2374 18.5837 18.677C18.5837 17.6498 19.0506 16.249 20.0778 14.7549C20.9183 14.2879 21.8521 13.7276 22.5058 13.2607C27.7354 10.2724 33.7121 4.76265 33.9922 1.21401V1.12062C33.9922 0.840467 33.8054 0.466926 33.6187 0.280156C33.2451 0.0933852 32.8716 0 32.5914 0ZM31.9377 1.68093C32.3113 1.49416 32.4047 1.58755 32.3113 1.8677C32.1245 2.24125 31.3774 4.57588 25.8677 9.15175C24.4669 10.3658 23.3463 11.0195 21.3852 12.2335C24.7471 7.37743 29.7899 3.1751 31.9377 1.68093Z"
        fill={color2}
      />
      <path
        d="M28.3891 4.85608L5.32295 9.8055L4.3891 12.2335L28.4825 6.35024V4.7627L28.3891 4.85608Z"
        fill={color1}
      />
    </svg>
  );
};
